import EnrollmentGroupAPI from '@/apis/business/enrollmentGroupAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('EnrollmentGroup', EnrollmentGroupAPI)

export default {
  namespaced: true,
  state: {
    ...crudBase.state,
    _config: {
      field: {
        key: 'Id',
        name: 'EnrollmentGroup',
      },
    },
    listYearBorn: [],

    listAdmissionGroup: [],

    admissionGroup: {},

  },
  mutations: {
    ...crudBase.mutations,
    /**
     * Cập nhật danh sách nhóm
     * @param {*} state
     * @param {*} data
     */
    setListAdmissionGroup (state, data) {
      state.listAdmissionGroup = data
    },

    /**
     *
     * @param {*} state
     * @param {*} data
     */
    setAdmissionGroup (state, data) {
      state.admissionGroup = data
    },

    setListYearBorn (state, data) {
      state.listYearBorn = data
    },

  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,

    getListYearBorn: async ({ commit }, schoolYear) => {
      const result = await EnrollmentGroupAPI.getListYearBorn(schoolYear)
      commit('setListYearBorn', result.PageData)
    },
    /**
     * Lấy các nhóm tuyển sinh đã được gộp đợt
     * @param {*} param0
     * @param {*} model
     * @returns
     */
    getEnrollmentGroup: async ({ commit }, model) => {
      const result = await EnrollmentGroupAPI.getEnrollmentGroup(model)
      return result
    },

    /**
     * Lấy lên tất cả các nhóm của các đợt tuyển sinh
     * @param {*} param0
     * @param {*} model
     * @returns
     */
    getAllEnrollmentGroup: async ({ commit }, model) => {
      const result = await EnrollmentGroupAPI.getAllEnrollmentGroup(model)
      return result
    },

    /**
     * Lấy lên tất cả các nhóm của các đợt tuyển sinh
     * @param {*} param0
     * @param {*} model
     * @returns
     */
    getEnrollmentGroupsForClassArrangement: async ({ commit }, model) => {
      const result = await EnrollmentGroupAPI.getEnrollmentGroupsForClassArrangement(model)
      return result
    },

  },
}
